import React from "react"
import { useTranslation } from "react-i18next"
import { Typography, styled } from "@mui/material"

const DescriptionComponent = () => {
  const { t } = useTranslation()

  return (
    <Description variant="subtitle2">
      {t("features.payment_schedule.form.description")}
    </Description>
  )
}

export default DescriptionComponent

const Description = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  fontWeight: "300",
  margin: "4px auto 36px auto",
  maxWidth: "780px",
  [theme.breakpoints.down("md")]: {},
}))
